import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"

import "./list.vue?vue&type=style&index=0&id=eb92ff72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb92ff72"]])

export default __exports__